import { createApp } from 'vue';
import IcoToPngConverter from '@/Components/IcoToPngConverter.vue';
import '@styles/app.css';

createApp(IcoToPngConverter).mount('#ico-to-png-converter');
